import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { useServicesQuery } from '../../queries/services'
import ServicesList from '../../components/services/list'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { Box, Element, Form, Icon, Message } from 'react-bulma-components'
import { AddResourceIcon, WarningIcon } from '../../components/icons'
import ServiceExplanation from '../../components/services/service-explanation'
import ServiceModalForm from '../../components/services/service-modal-form'
import { Service } from '../../api/services'

/**
 * Component for managing employer services
 */
const ServicesSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const [showInactive, setShowInactive] = React.useState(false)
  const query: { isInactive?: boolean[] | boolean } = {}
  if (showInactive) {
    query.isInactive = true
  }
  const { data: services } = useServicesQuery(query, {
    enabled: Boolean(employer),
  })
  const [currentService, setCurrentService] = React.useState<Service | 'new' | undefined>()

  return (
    <>
      <SidebarContentTitle
        title="Affectations"
        onButtonClick={() => setCurrentService('new')}
        addButtonLabel="Nouvelle affectation"
        ButtonIcon={AddResourceIcon}
        help={<ServiceExplanation textColor={'white'} />}
        buttonDataTestId="create-service-button"
      />
      <Box>
        {showInactive && (
          <Message color="info" className="mb-4">
            <Message.Body>
              <Icon.Text>
                <Icon>
                  <WarningIcon />
                </Icon>
                Vous affichez uniquement les affectations inactives.
                <br /> Ces affectations ne sont plus utilisées dans les missions et les demandes.
                Vous pouvez les réactiver en les modifiant.
              </Icon.Text>
            </Message.Body>
          </Message>
        )}
        <ServicesList
          data={services || []}
          onServiceClick={service => setCurrentService(service)}
        />
        <Element textAlign={'right'}>
          <Form.Field>
            <Form.Control>
              <Form.Checkbox
                checked={showInactive}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setShowInactive(e.target.checked)
                }
                data-test="show-inactive-services-checkbox"
              >
                Afficher les affectations inactives
              </Form.Checkbox>
            </Form.Control>
          </Form.Field>
        </Element>
      </Box>
      <ServiceModalForm
        isDisplayed={Boolean(currentService)}
        setIsDisplayed={() => setCurrentService(undefined)}
        service={currentService === 'new' ? undefined : currentService}
      />
    </>
  )
}

export default ServicesSettings
